import { rem, spacing } from '@koaly/mixins';
import { breakpoints } from './breakpoints.js';
import { colorTokens } from './colors.js';
import { componentTokens } from './components.js';
import { fontStylesTokens } from './fontStyles.js';

const koalyTheme = {
    colors: colorTokens,
    tokens: {
        fontFamily: '\'Montserrat\', sans-serif',
        headingFontFamily: '@self.tokens.fontFamily',
        // Container
        containerMaxWidth: rem(1060),
        // Text tokens
        textPrimaryColor: '@self.colors.primary.800',
        textSecondaryColor: '@self.colors.primary.800',
        textGreyColor: '@self.colors.grey.650',
        // Background tokens
        backgroundPrimary: '@self.colors.primary.100',
        backgroundSecondary: '@self.colors.primary.200',
        // Link Tokens
        linkPrimaryColor: '@self.colors.primary.800',
        linkPrimaryColorHover: '@self.colors.primary.600',
        linkPrimaryColorActive: '@self.colors.primary.800',
        linkSecondaryColor: '@self.colors.primary.800',
        linkSecondaryColorHover: '@self.colors.primary.600',
        linkSecondaryColorActive: '@self.colors.primary.650',
        linkGreyColor: '@self.colors.grey.800',
        linkGreyColorHover: '@self.colors.grey.600',
        linkGreyColorActive: '@self.colors.grey.800',
        // Navigation Tokens
        navigationPrimaryBorderColorActive: '@self.colors.primary.600',
        navigationSecondaryBorderColorActive: '@self.colors.primary.600',
        // Action tokens
        // Content Section
        contentSectionSpacingVertical: spacing(40),
        contentSectionMobilePaddingVertical: spacing(20),
        contentMaxWidth: rem(1060),
        contentBlockSpacing: rem(80),
        elevationColor: '@self.colors.primary.opacity',
        headingColor: '@self.colors.primary.800',
    },
    // Elevations
    elevations: {
        1: '0px 2px 6px [@self.tokens.elevationColor]',
        2: '0px 4px 8px [@self.tokens.elevationColor]',
        3: '0px 8px 32px [@self.tokens.elevationColor]',
        4: '0px 16px 48px [@self.tokens.elevationColor]',
    },
    fontStyles: fontStylesTokens,
    components: componentTokens,
    breakpoints: breakpoints,
};

export { koalyTheme };
//# sourceMappingURL=theme.js.map
